import _http from './_http';
import { logWebHrError } from '@/core/logger/log-wrapper';
let http = _http;

if (process.env.MOCK) {
  const superfunds = require('./_mock.json').superfund;
  http = {
    get: (query) =>
      Promise.resolve().then(() => {
        query = query.replace('/onboarding/superfund/', '');

        const ret = superfunds.data
          .filter((superfund) => {
            const concatenated = `${superfund.FundName.toLowerCase()} ${superfund.ProductName.toLowerCase()} ${
              superfund.USI
            } ${superfund.ABN}`;
            return !!concatenated.match(query.toLowerCase());
          })
          .map((superfund) => {
            superfund.id = superfund.USI.toString();
            superfund.description = superfund.ProductName;

            return superfund;
          });

        return {
          data: {
            data: ret,
          },
        };
      }),
  };
}

const baseUrl = '/onboarding/superfund';

export default {
  url: `${http.baseUrl}${baseUrl}`,
  get(query) {
    return http
      .post(`${baseUrl}`, { term: query })
      .then(({ data }) => data.data)
      .catch((e = {}) => {
        if (e.response?.status !== 404) {

          logWebHrError({
            message: 'Failed to query superfund due to error',
            source: 'superfund',
            error: e,
          });
        }

        if (e.response && e.response.data) {
          throw e.response.data.error;
        }

        throw e.response;
      });
  },
};
